import { Container, Stack } from '@mui/material';

const MainContainer = ({ children }: any) => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ display: 'flex', justifyContent: 'center' }}
    >
      <Stack direction="row" spacing={0} sx={{ maxWidth: '100%' }}>
        {children}
      </Stack>
    </Container>
  );
};

export default MainContainer;
